// @flow
import * as React from 'react';
import Image from 'gatsby-image/withIEPolyfill';

import type { File } from '~schema';

type Props = {
  ...$Exact<
    $Diff<
      React.ElementConfig<typeof Image>,
      {
        resolutions: any,
        sizes: any,
        fixed: any,
        fluid: any,
      },
    >,
  >,
  file: ?File,
  ImageComponent?: React.ComponentType<React.ElementConfig<typeof Image>>,
};

const FileImage = ({ ImageComponent = Image, file, ...props }: Props) =>
  file && file.childImageSharp ? (
    <ImageComponent
      {...props}
      // $FlowFixMe --> Reason: trust that the proper fragment has been used on the query
      resolutions={file.childImageSharp.resolutions}
      // $FlowFixMe --> Reason: trust that the proper fragment has been used on the query
      fixed={file.childImageSharp.fixed}
      // $FlowFixMe --> Reason: trust that the proper fragment has been used on the query
      fluid={file.childImageSharp.fluid}
      // $FlowFixMe --> Reason: trust that the proper fragment has been used on the query
      sizes={file.childImageSharp.sizes}
    />
  ) : null;

FileImage.defaultProps = {
  ImageComponent: undefined,
};

export default FileImage;
